"use client";

import { c as _c } from "react/compiler-runtime";
import { RETURN_POLICY_URL } from "@/lib/return-policy";
import { useEffect, useState } from "react";
const benefits = ["No auction cars.", "No haggling.", "No dealer fees.", "Return/exchange options. Terms apply."];
export default function SRPBenefitsBar() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [0, 2];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [mobileIndices, setMobileIndices] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const firstIndex = Math.floor(Math.random() * benefits.length);
      const remainingIndex = Math.floor(Math.random() * (benefits.length - 1));
      const secondIndex = remainingIndex >= firstIndex ? remainingIndex + 1 : remainingIndex;
      setMobileIndices([firstIndex, secondIndex].sort(_temp));
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== mobileIndices) {
    t3 = benefits.map((benefit, index) => {
      const mobilePosition = mobileIndices.indexOf(index);
      return <li key={benefit} className={`${mobilePosition < 0 ? "t-hidden md:t-flex" : "t-flex"} ${mobilePosition === 1 ? "t-border-l" : "t-border-l-0"} t-min-w-0 t-w-1/2 t-items-center t-justify-center t-border-solid t-border-brand-ink/20 t-px-3 t-text-center t-text-xs t-font-bold t-leading-5 md:t-w-auto md:t-px-6 md:t-text-sm ${index > 0 ? "md:t-border-l" : "md:t-border-l-0"}`}>{index === 3 ? <a href={RETURN_POLICY_URL} className="t-underline t-underline-offset-2">{benefit}</a> : benefit}</li>;
    });
    $[3] = mobileIndices;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <aside aria-label="The THIScar difference" className="t-bg-brand-yellow t-text-brand-ink"><ul role="list" className="t-m-0 t-flex t-list-none t-items-stretch t-justify-center t-px-4 t-py-3 sm:t-px-6">{t3}</ul></aside>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp(a, b) {
  return a - b;
}